<template>

<div class="form-row">
    <div class="form-group col-md-12">
        <!--<label>Permissions</label>-->
        <!--<input class="form-control" type="text" v-model="form.permissions">-->
        <div class="form-group row">
            <label class="col-md-12 my-2 control-label">Check the boxes you wish to grant user permission to:</label>
            <div class="col-12 app-roles">
                <table class="table tableRoles">
                    <thead>
                        <tr>
                            <th scope="col" class="firstTh">
                                <label class="m-0">
                                    <input type="checkbox" class="align-middle"
                                        id="active_all_menus" name="active_all_menus"
                                        @change="selectAllMenus()" v-model="checkedAllMenus" />
                                    <span class="ml-1 align-middle">Modules</span>
                                </label>
                            </th>

                            <th scope="col" v-for="action in actionsTotal" :key="action">
                                <label class="m-0">
                                    <input type="checkbox" class="align-middle" :value="false"
                                        @change="updateAllAction(action)" v-model="checkedAllAction[action]">
                                    <span class="ml-1 align-middle">{{ action }}</span>
                                </label>
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <template v-for="menu in form.permissions">
                            <tr :key="menu.key">
                                <th :colspan="1 + Object.keys(actionsTotal).length" class="nameModule">
                                    <label class="m-0">
                                        <input type="checkbox" class="align-middle"
                                            :id="'active_menu_'+menu.key"
                                            :name="'menu['+menu.key+'][active]'"
                                            @change="updateMenu(menu)"
                                            v-model="menu.active"
                                            >
                                        <span v-if="menu.label" class="ml-1 align-middle">{{ menu.label.toLowerCase() }}</span>
                                    </label>
                                </th>
                            </tr>

                            <tr v-for="submenu in menu.items" :key="menu.key+'-'+submenu.key">
                                <td class="firstModuleOption">
                                    <label class="m-0">
                                        <input type="checkbox" class="ml-4 align-middle"
                                            :id="'active_submenu_'+submenu.key"
                                            :name="'menu['+ menu.key + '][submenus][' +submenu.key + '][active]'"
                                            @change="updateSubMenu(submenu, menu)"
                                            v-model="submenu.active"
                                            >
                                        <span v-if="submenu.label"  class="ml-1 align-middle">{{ submenu.label.toLowerCase() }}</span>
                                    </label>
                                </td>
                                <td v-for="action in actionsTotal" :key="action">
                                    <label class="m-0" v-if="submenu.actions[action]">
                                        <input type="checkbox" class="align-middle"
                                            :id="'active_submenu_'+submenu.key+'_action_'+action"
                                            :name="'menu['+ menu.key + '][submenus][' + submenu.key + '][actions]['+submenu.actions[action].key+'][active]'"
                                            @change="updateAction(submenu.actions[action], submenu, menu)"
                                            v-model="submenu.actions[action].active"
                                            >
                                        <span class="ml-1 align-middle d-none d-md-inline-block">
                                            {{ action }}
                                        </span>
                                    </label>
                                    <span v-else>-</span>
                                </td>
                            </tr>
                        </template>
                    </tbody>
                </table>
            </div>
        </div>
        <form-error-component :errors="errors" v-if="errors.permissions">
          {{ errors.permissions[0] }}
        </form-error-component>
    </div>
</div>



</template>

<script>
import FormErrorComponent from "../../FormErrorComponent";

export default {
    name: "RoleFormComponent",
    components: {FormErrorComponent},
    props: {
        permissions: {
            type: Array,
            default: []
        },
    },
    data() {
        return {
            method: "POST",
            formPermissions: [],
            form: {},
            isCheckAll: {},
            allParentMenu: [],
            errors: {},
            checkedAllMenus: false,
            checkedAllAction: {},
            actionsTotal: {},
        }
    },
    methods: {

        selectAllMenus() {

            let checkedAllMenus = this.checkedAllMenus;
            this.form.permissions.forEach( menu => {
                menu.active = checkedAllMenus;

                this.selectAllSubMenus(menu);
            });

            for (var action in this.actionsTotal) {
                this.checkedAllAction[action] = checkedAllMenus;
            }
        },

        selectAllSubMenus(menu) {
            menu.items.forEach( submenu => {
                submenu.active = menu.active;

                this.selectAllSubMenuActions(submenu, menu);
            });
        },

        selectAllSubMenuActions(submenu, menu) {

            for(var action in this.actionsTotal) {

                if(submenu.actions[action]) {
                    submenu.actions[action].active = submenu.active;
                }
            };
        },

        updateMenu(menu) {

            this.selectAllSubMenus(menu);
            this.verifyMenusChecked();
            this.verifyActionsAll();
            this.$forceUpdate()
        },
        updateSubMenu(submenu, menu) {

            this.selectAllSubMenuActions(submenu, menu);
            this.verifySubMenusChecked(menu);
            this.verifyMenusChecked();
            this.verifyActionsAll();
            this.$forceUpdate()
        },
        updateAction(action, submenu, menu) {

            this.verifyActionsChecked(submenu);
            this.verifySubMenusChecked(menu);
            this.verifyMenusChecked();
            this.verifyActionsAllByKey(action.key);
            this.$forceUpdate()
        },

        updateAllAction(actionKey) {

            this.form.permissions.forEach( function(menu) {

                menu.items.forEach( function(submenu) {

                    if(submenu.actions[actionKey]){
                        submenu.actions[actionKey].active = this.checkedAllAction[actionKey];
                        this.verifyActionsChecked(submenu);
                    }

                }, this);
                this.verifySubMenusChecked(menu);

            }, this);
            this.verifyMenusChecked();
            this.$forceUpdate()
        },

        verifyMenusChecked() {
            let count = 0;
            this.form.permissions.forEach( function(menu){

                if(menu.active) {
                    count++;
                }
            });

            if(count == 0) this.checkedAllMenus = false;

            else this.checkedAllMenus = true;
            this.$forceUpdate()
        },

        verifySubMenusChecked(menu) {
            let count = 0;
            menu.items.forEach( function(submenu) {

                if(submenu.active) count++;
            });

            if(count == 0) menu.active = false;

            else menu.active = true;
        },

        verifyActionsChecked(submenu) {
            let count = 0;

            for(var action in this.actionsTotal) {
                if(submenu.actions[action] && submenu.actions[action].active) count++;
            };

            if(count > 0) submenu.active = true;
        },

        verifyActionsAll() {

            for (var actionKey in this.actionsTotal){

                this.verifyActionsAllByKey(actionKey);
            }
        },

        verifyActionsAllByKey(actionKey) {

            let count = 0;
            this.form.permissions.forEach( function(menu) {

                menu.items.forEach( function(submenu) {

                    if(submenu.actions[actionKey] && submenu.actions[actionKey].active) count++;

                }, this);

            }, this);

            if(count == 0) this.checkedAllAction[actionKey] = false;

            else this.checkedAllAction[actionKey] = true;
        },

        getUniqueActions() {
            this.form.permissions.forEach( function(menu) {
                menu.items.forEach( function(submenu) {

                    for(var action in submenu.actions) {
                        this.actionsTotal[action] = action;
                    }

                }, this);

            }, this);
        }
    },
    created() {
        this.form.permissions = this.permissions
        this.getUniqueActions();
        this.verifyActionsAll();
        this.verifyMenusChecked();

    },

}
</script>

<style scoped>

</style>
